module.exports = __webpack_public_path__ + "static/img/rddExpenseTax_3_2.b5a6c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/rddExpenseTax/rddExpenseTax_3_2.png
// module id = wvyw
// module chunks = 34